import React from 'react'

import UnidadComponentLoader from './UnidadComponentLoader'

const Mediacion = React.lazy(() => import('./mediacion/ActosPostFirma'))
const Correduria = React.lazy(() => import('./correduria/ActosPostFirma'))

export default function InfoPreliminar(params) {

    return (                     
        <UnidadComponentLoader 
            {...params}
            correduria={Correduria}
            mediacion={Mediacion}
        ></UnidadComponentLoader>       
    )

}